<template>
  <div class="mt-3">
    <form method="post">
      <div class="card vue-avatar-cropper-demo text-center">
        <div class="card-body text-center">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-btn id="pick-avatar" color="primary">Avatar</v-btn>
            </v-col>
          </v-row>
        </div>
        <avatar-cropper
            @uploading="handleUploading"
            @uploaded="handleUploaded"
            @completed="handleCompleted"
            @error="handlerError"
            trigger="#pick-avatar"
            upload-url="https://admin.xlogistics.it/ajax/settings/upload.php" />
      </div>
    </form>
  </div>
</template>

<script>
import AvatarCropper from "./AvatarCropper";

export default {
  components: { AvatarCropper },
  data() {
    return {
      page: "BossAccount",
      message: "",
      user: {
        id: 1,
        nickname: "",
        username: "",
        avatar: ""
      }
    };
  },
};
</script>
